import {
  Alert,
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLSelect,
  HTMLTable,
  InputGroup,
  Popover,
  Spinner,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBContainer,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel, IViewModel } from "mobx-utils";
import * as React from "react";
import { api } from "../../api";
import { IContador, IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { ContadorDialogStore } from "../../stores/perfil/ContadorDialogStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { mascara_inscricao_estadual, municipios_liberados, validarCNPJ } from "../../utils";
import EmpresaCertificado from "./../empresa-edit/certificado";
import EmpresaPgdas from "./../empresa-edit/pgdas";
import EmpresaSefa from "./../empresa-edit/sefa";
import EmpresaTributacao from "./../empresa-edit/tributacoes";
import Cookies from 'universal-cookie';
import EmpresaParauapebas from "../empresa-edit/parauapebas";
import EmpresaCalculos from "../empresa-edit/calculos";
import EmpresaSped from "../empresa-edit/sped";
import LoadingModal from "../loading/LoadingModal";
import moment from "moment";
import EmpresaCaixaPostal from "../empresa-edit/caixapostal";

const cookies = new Cookies()
const BrV = require("br-validations");
const InputMask = require("react-input-mask");

require("../../assets/css/components/EmpresaForm.css");

interface IEmpresaFormProps {
}

@observer
export default class EmpresaForm extends React.Component<IEmpresaFormProps, any> {

  obs = observable({
    focusEl: {} as HTMLElement,
    empresa: {} as IEmpresa & IViewModel<IEmpresa>,
    nome_user: "" as string,
    email_user: "" as string,
    senha_user: "" as string,
    empresa_id: "" as string,
    nome_certificado: "" as string,
    certificado: [] as any,
    faixa: [] as any,
    showingAlertTermosUser: false as boolean,
    situacao: "" as string,
    anexo_ref: "" as string,
    receitaBruta: "" as string,
    valueCurrency: [] as any,
    // pgdas_invalid: false as boolean,
    validando: false as boolean,
    handleModalCertTeste: false as boolean,
    handleModalRegimeLog: false as boolean,
    handleModalTributacoes: false as boolean,
    tributacaoAlteracao: "" as string,
    regimeAlteracao: "" as string,
    receita_bruta: "" as string,
    cod_acesso: "" as string,
    contadores_list: [] as IContador[],
    contador_name: "" as string,
    selectedTab: "empresa" as string,
    anexo_confirmacao: false as boolean,
    anexo_pdf: "" as string,
    anexo_static: "" as string,
    sum: 0.0 as number,
    sum_externa: 0.0 as number,
    empresaId: window.location.pathname.split("/")[3] as string,
    tree: {} as any,
    conta_contabil: [] as any[],

    classificacao_conta: "" as string
  })


  constructor(props: IEmpresaFormProps) {
    super(props);
    AppStore.setTitle("Editar Empresa");
    EmpresaStore.obs.empresa_edit = createViewModel(newEmpresa());
    this.state = {};
  }

  async componentDidMount() {

    const cookies_data = cookies.get('__EMP-PARCE');

    if (cookies_data && cookies_data.tab) {

      this.obs.selectedTab = cookies_data.tab

      cookies.remove('__EMP-PARCE', { path: '/' });

    }

    this.obs.focusEl.focus();
    EmpresaStore.obs.working = false;
    await ContadorDialogStore.handleGetContadores();

    this.obs.contadores_list = ContadorDialogStore.obs.contadores_list;

    if (this.obs.empresaId) {
      try {
        let empresa = await EmpresaStore.handleDadosEmpresa(this.obs.empresaId);

        if (empresa) {

          EmpresaStore.obs.usuarios = [];
          EmpresaStore.obs.usuarios = empresa.usuarios

          EmpresaStore.obs.empresa_edit = empresa

          this.handleSetContador(empresa.contador_responsavel);

          EmpresaStore.obs.exist_pdf = await EmpresaStore.exist_pdf_pref()

          EmpresaStore.obs.existe_pdf_pgdas = await EmpresaStore.exist_pdf_pgdas()

        } else {

          AppStore.setLocation("/empresas")

        }

      } catch (ex) {
        toast.error(`Erro ao carregar Empresa!`, {});
      }

    }

    this.setState({ aceito_termos: "Não Aceito" });

  }

  handleCheckFilial = (filial: string) => {
    let fil;
    if (filial == "true") {
      fil = true;
    } else {
      fil = false;
    }
    this.setState({ filial: fil });
    EmpresaStore.obs.empresa_edit.filial = fil;
    EmpresaStore.obs.filial = fil;
  };

  handleCheckRegime = (regime: string) => {
    EmpresaStore.obs.empresa_edit.regime_importacao = regime
  };

  handleRemoveUsuario = async (usuario: any) => {

    let data = {
      id: usuario._id,
      id_empresa: EmpresaStore.obs.empresa_edit._id
    }

    let resp = await api.post(`/api/usuario-empresa/remove`, data);

    if (resp.data.ok) {

      toast.success('Usuário removido com sucesso', {});

    } else {

      toast.error(resp.data.msg, {});

    }

    setTimeout(() => { window.location.reload() }, 1000);

  };

  handleSave = async () => {

    const v = EmpresaStore.obs.empresa_edit.parcelamentos_numero;
    console.log('parcelamentos_numero typeof:', typeof v, '| valor:', v, '| tem .replace?:', typeof (v as any)?.replace);


    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    if(EmpresaStore.obs.empresa_edit.calculo_automatico_nivy && !EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_entrada && !EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_saida) {
      toast.warning('Para prosseguir com a Importação Automática de XML da SEFA, selecione ao menos uma opção: Entrada e/ou Saída.', {});
      return;
    }

    let cpfSefa = (EmpresaStore.obs.empresa_edit.cpf_sefa || "").replace(/[^0-9]/g, '').toString()
    EmpresaStore.obs.empresa_edit.cpf_sefa = cpfSefa;

    let cpfGov = (EmpresaStore.obs.empresa_edit.cpf_gov || "").replace(/[^0-9]/g, '').toString()
    EmpresaStore.obs.empresa_edit.cpf_gov = cpfGov;

    let cpfSocio = (EmpresaStore.obs.empresa_edit.cpf_socio || "").replace(/[^0-9]/g, '').toString()
    EmpresaStore.obs.empresa_edit.cpf_socio = cpfSocio;

    if (EmpresaStore.obs.empresa_edit.sefa_metodo_login == "gov_senha" && (!cpfGov || !EmpresaStore.obs.empresa_edit.senha_gov)) {
      toast.warning("Favor verifique se os campos CPF e Senha estão preenchidos corretamente na autenticação da SEFA.", {});
      return
    }

    if (EmpresaStore.obs.empresa_edit.autenticacao_dei == "1" && (!cpfSefa || !EmpresaStore.obs.empresa_edit.senha_sefa)) {
      toast.warning("Favor verifique se os campos CPF e Senha estão preenchidos corretamente na autenticação do DEI.", {});
      return
    }

    if (EmpresaStore.obs.empresa_edit.autenticacao_dei == "3" && (!cpfGov || !EmpresaStore.obs.empresa_edit.senha_gov)) {
      toast.warning("Favor verifique se os campos CPF e Senha estão preenchidos corretamente na autenticação do DEI.", {});
      return
    }

    if (EmpresaStore.obs.empresa_edit.autenticacao_sefa == "2" && (!cpfSocio || !EmpresaStore.obs.empresa_edit.senha_socio)) {
      toast.warning("Favor verifique se os campos CPF e Senha estão preenchidos corretamente na autenticação do PARCELAMENTO SEFA.", {});
      return
    }

    if ((EmpresaStore.obs.empresa_edit.send_das || EmpresaStore.obs.empresa_edit.send_pgdas) && !regex.test(EmpresaStore.obs.empresa_edit.pgdas_email)) {
      toast.warning("E-mail para cópias dos arquivos PGDAS está inválido!", {});
      return
    }

    if (EmpresaStore.obs.empresa_edit.email_calculos && !regex.test(EmpresaStore.obs.empresa_edit.email_calculos)) {
      toast.warning("E-mail para envio dos Erros de Cálculo está inválido!", {});
      return
    }

    if (EmpresaStore.obs.empresa_edit.send_parcelas) {
      const emails = EmpresaStore.obs.empresa_edit.parcelamentos_email
        .split(",")
        .map(e => e.trim())
        .filter(Boolean)

      const hasInvalid = emails.some(e => !regex.test(e))

      if (hasInvalid) {
        toast.warning("E-mail para cópias dos arquivos SEFA | e-CAC está inválido!", {})
        return
      }
    }

    let parcelamentos_numero = (EmpresaStore.obs.empresa_edit.parcelamentos_numero || [])
    EmpresaStore.obs.empresa_edit.parcelamentos_numero = parcelamentos_numero;

    if (EmpresaStore.obs.empresa_edit.send_parcelas_message && !parcelamentos_numero.length) {
      toast.warning("Informe pelo menos um telefone para receber as cópias das parcelas.", {});
      return
    }

    let pgdas_numero = (EmpresaStore.obs.empresa_edit.pgdas_numero || [])
    EmpresaStore.obs.empresa_edit.pgdas_numero = pgdas_numero;

    if ((EmpresaStore.obs.empresa_edit.send_message_das || EmpresaStore.obs.empresa_edit.send_message_pgdas) && !pgdas_numero.length) {
      toast.warning("Informe pelo menos um telefone para receber as cópias dos arquivos do PGDAS.", {});
      return
    }

    let dec_sefa_numeros: string[] = (EmpresaStore.obs.empresa_edit.dec_sefa_numero || [])
    EmpresaStore.obs.empresa_edit.dec_sefa_numero = dec_sefa_numeros;

    if (EmpresaStore.obs.empresa_edit.dec_sefa_message && !dec_sefa_numeros.length) {
      toast.warning("Informe pelo menos um telefone para receber os avisos do DEC SEFA.", {});
      return
    }

    let det_numero: string[] = (EmpresaStore.obs.empresa_edit.det_numero || [])
    EmpresaStore.obs.empresa_edit.det_numero = det_numero;

    if (EmpresaStore.obs.empresa_edit.det_message && !det_numero.length) {
      toast.warning("Informe pelo menos um telefone para receber os avisos do DET.", {});
      return
    }

    let caixa_postal_numero = (EmpresaStore.obs.empresa_edit.caixa_postal_numero || "").replace(/[^0-9]/g, '').toString()
    EmpresaStore.obs.empresa_edit.caixa_postal_numero = caixa_postal_numero;

    if (EmpresaStore.obs.empresa_edit.send_message_caixa_postal && !caixa_postal_numero) {
      toast.warning("Telefone para avisos Caixa Postal está inválido!", {});
      return
    }

    let cpfFormat = (EmpresaStore.obs.empresa_edit.cpf_responsavel || "").replace(/[^0-9]/g, '').toString()
    EmpresaStore.obs.empresa_edit.cpf_responsavel = cpfFormat;

    let simples = EmpresaStore.obs.empresa_edit.simples_nacional;

    if (!simples) {
      EmpresaStore.obs.empresa_edit.plano = "normal";
    } else {
      EmpresaStore.obs.empresa_edit.plano = "simples";
    }

    if (!EmpresaStore.obs.empresa_edit.razao_social) {
      toast.error('Preencha o campo Razão social', {});
      return;
    }

    if (!EmpresaStore.obs.empresa_edit.cnpj) {
      toast.error('Preencha o campo CNPJ', {});
      return;
    }

    if (!validarCNPJ(EmpresaStore.obs.empresa_edit.cnpj)) {
      toast.error('CNPJ inválido', {});
      return;
    }

    if (EmpresaStore.obs.empresa_edit.inscricao_estadual != "") {

      let inscricaoEstadual = (EmpresaStore.obs.empresa_edit.inscricao_estadual?.replace(/[^0-9]/g, '')).toString()

      EmpresaStore.obs.empresa_edit.inscricao_estadual = inscricaoEstadual;

    }

    var id = EmpresaStore.obs.empresa_edit.cipher_id;

    if (this.state.aceito_termos == "Aceito") {

      let resp = api.get(`/api/acao-certificado?id=${id}&acao=aceito`);

    }

    if (this.state.filial == true) {
      EmpresaStore.obs.empresa_edit.filial = true;
    } else {
      EmpresaStore.obs.empresa_edit.filial = false;
    }

    if (EmpresaStore.obs.empresa_edit.receita_bruta !== 0) {
      EmpresaStore.obs.empresa_edit.receita_bruta = 8000;
    }

    if (EmpresaStore.obs.empresa_edit.sped_valor_inicial_data && (EmpresaStore.obs.empresa_edit.sped_valor_inicial == null || EmpresaStore.obs.empresa_edit.sped_valor_inicial == undefined)) {
      toast.warn("Por favor, preencha o campo 'Saldo Credor Anterior' para a data selecionada.");
      return;
    }

    if (!EmpresaStore.obs.empresa_edit.sped_valor_inicial_data) {

      EmpresaStore.obs.empresa_edit.sped_valor_inicial = null
      EmpresaStore.obs.empresa_edit.sped_valor_inicial_data = null

    } else {

      EmpresaStore.obs.empresa_edit.sped_valor_inicial_data = moment(EmpresaStore.obs.empresa_edit.sped_valor_inicial_data).add(3, "hours").format("YYYY-MM-DD")

    }

    this.doSave();

  };

  doSave = async () => {
    try {

      await EmpresaStore.updateEmpresa(EmpresaStore.obs.empresa_edit);

    } catch (ex) {

      if (ex.response.status == 403) {

        toast.error('Não foi possível vincular esta empresa com um plano, porque a sua conta não tem mais CNPJs disponíveis.', {});

      } else {

        toast.error(String(ex), {});

      }
    }
  };

  handlesDownloadpgdas = async () => {

    await EmpresaStore.visualiza_pgdas(EmpresaStore.obs.empresa_edit);

  };

  handleSetContador(id: string) {
    for (let i = 0; i < ContadorDialogStore.obs.contadores_list.length; i++) {
      if (ContadorDialogStore.obs.contadores_list[i].id == id) {
        EmpresaStore.obs.empresa_edit.contador_responsavel = ContadorDialogStore.obs.contadores_list[i].id;
        ContadorDialogStore.obs.contador_selected = ContadorDialogStore.obs.contadores_list[i].nome;
      }
    }
  }

  handleCancel = () => {
    AppStore.setLocation("/empresas");
  };

  handleCancelTributacao = () => {
    this.obs.handleModalTributacoes = false;
  };

  handleConfirmTributacao = () => {
    this.obs.handleModalTributacoes = false;
  };

  haldleDisableValidSimples = () => {
    let login_email = AppStore.obs1.usuario ? AppStore.obs1.usuario.email : "";

    if (!EmpresaStore.obs.empresa_edit.simples_nacional) {
      return true;
    }

    if (
      login_email == "__ADMIN__@fipo.com.br" ||
      login_email == "thiago@fipo.com.br"
    ) {
      return false;
    } else if (
      !this.obs.receitaBruta && EmpresaStore.obs.empresa_edit.simples_nacional
    ) {
      return false;
    }

    return true;
  };

  handleSimplesNacionalSelect = (value: any) => {
    EmpresaStore.obs.empresa_edit.simples_nacional = value == "1";
    this.obs.tributacaoAlteracao = "Simples Nacional";
    this.obs.handleModalTributacoes = true;

    if (EmpresaStore.obs.empresa_edit.simples_nacional) {

      this.setState({ arquivo_pgdas: false, select_pgdaz: false });
      EmpresaStore.obs.empresa_edit.simples_nacional_excesso = false

    } else {

      this.setState({ arquivo_pgdas: true, select_pgdaz: true });
      EmpresaStore.obs.empresa_edit.simples_nacional_excesso = false

    }

  };

  handleRegimeEspecialSelect = (value: any) => {
    EmpresaStore.obs.empresa_edit.regime_especial_icms_pa = value == "1";
    this.obs.tributacaoAlteracao = "Regime Especial";
    this.obs.handleModalTributacoes = true;
  };

  handleConvenioIcms10097Select = (value: any) => {
    this.obs.tributacaoAlteracao = "Convênio ICMS 100/97";
    EmpresaStore.obs.empresa_edit.convenio_icms_100_97 = value == "1";
    this.obs.handleModalTributacoes = true;
  };

  handleMedicamentoUsoVeterinarioSelect = (value: any) => {
    this.obs.tributacaoAlteracao = "Medicam. Veteri. PET";
    EmpresaStore.obs.empresa_edit.medicamento_uso_veterinario = value == "1";
    this.obs.handleModalTributacoes = true;
  };
  handleAutoPecasSelect = (value: any) => {
    this.obs.tributacaoAlteracao = "Auto Peças";
    EmpresaStore.obs.empresa_edit.auto_pecas = value == "1";
    this.obs.handleModalTributacoes = true;
  };

  handleSimplesNacionalExcesso = (value: any) => {
    this.obs.tributacaoAlteracao = "Ultrapassou Limite";
    EmpresaStore.obs.empresa_edit.simples_nacional_excesso = value == "1"
    this.obs.handleModalTributacoes = true;
  }
  handlePortaaPortaSelect = (value: any) => {
    this.obs.tributacaoAlteracao = "Porta a porta";
    EmpresaStore.obs.empresa_edit.porta_a_porta = value == "1"
    this.obs.handleModalTributacoes = true;
  }

  handleIssTributadoFixoSelect = (value: any) => {
    EmpresaStore.obs.empresa_edit.tributa_fixo_iss = value == "1"
  }

  handleReceitaBrutaValid(e) {
    if (
      Number(e.split(" ").pop().replace(/\./g, "").replace(/\,/, ".")) === 0
    ) {
      this.obs.receita_bruta = "";
    } else {
      this.obs.receita_bruta = e;
    }
  }

  handleCodAcesso(e) {

    EmpresaStore.obs.empresa_edit.cod_acesso = e;

  }

  render() {

    let items = EmpresaStore.obs.usuarios?.map(usu => {
      return (
        <tr key={usu.id} className="nz-table-actions">
          <td>
            {usu.nome_completo}
          </td>
          <td>{usu.email}</td>
          <td>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Confirmar exclusão do usuário?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleRemoveUsuario.bind(this, usu)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    });

    return (
      <>

        <LoadingModal open={this.obs.validando} onClose={() => this.obs.validando = false} title={"Validando PGDAS"} />

        <Dialog
          isOpen={this.obs.handleModalTributacoes}
          title="Atenção"
          onClose={() => this.obs.handleModalTributacoes = false}
          style={{ width: 700 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="12">
                <h3 className="titleProccess">
                  Tributação Selecionada: <u>{this.obs.tributacaoAlteracao}</u>
                </h3>
                <h3 className="titleProccess">
                  A alteração da tributação irá impactar a data dos cálculos.
                </h3>
                <h3 className="titleProccess">
                  <u>
                    Certifique-se que realmente este é a tributação da sua
                    empresa e aceite os termos para trocar o regime.
                  </u>
                </h3>
              </MDBCol>
            </MDBRow>
            <Button
              onClick={() => this.handleCancelTributacao()}
              className="cancelCadEmp"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => this.handleConfirmTributacao()}
              className="certiDigitalTeste"
            >
              Aceito os Termos
            </Button>
          </div>
        </Dialog>

        <MDBRow>
          <Tabs
            id="tabs"
            className={"tabsCalculos tabsEmpresaForm"}
            selectedTabId={this.obs.selectedTab}
            onChange={(tabId) => this.obs.selectedTab = String(tabId)}
          >
            <Tab
              id="empresa"
              title="Dados da Empresa"
              panel={
                <MDBCol>

                  <div style={{ width: 1000 }}>

                    <FormGroup
                      label="Razão social"
                      labelFor="razao-social"
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <InputGroup
                        id="razao-social"
                        className="dataInput"
                        inputRef={el => this.obs.focusEl = el}
                        defaultValue={EmpresaStore.obs.empresa_edit.razao_social}
                        onChange={(e: any) =>
                          EmpresaStore.obs.empresa_edit.razao_social = e.target.value}
                      />
                    </FormGroup>

                    <FormGroup
                      label="Nome fantasia"
                      labelFor="nome-fantasia"
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <InputGroup
                        id="nome-fantasia"
                        defaultValue={EmpresaStore.obs.empresa_edit.nome_fantasia}
                        onChange={(e: any) =>
                          EmpresaStore.obs.empresa_edit.nome_fantasia = e.target.value}
                      />
                    </FormGroup>

                    <FormGroup
                      label="Apelido"
                      labelFor="nome-apelido"
                    >
                      <InputGroup
                        id="nome-apelido"
                        defaultValue={EmpresaStore.obs.empresa_edit.apelido}
                        onChange={(e: any) => EmpresaStore.obs.empresa_edit.apelido = e.target.value}
                      />
                    </FormGroup>

                    <FormGroup
                      label="CNPJ"
                      labelFor="cnpj"
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <InputGroup
                        value={EmpresaStore.obs.empresa_edit.cnpj.replace(
                          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                          "$1.$2.$3/$4-$5",
                        )}
                        disabled
                      />
                    </FormGroup>

                    <FormGroup
                      label="CPF do Responsável"
                      labelFor="cpf_responsavel"
                      style={{ width: "48%", float: "left" }}
                    >
                      <InputMask
                        className="form-control"
                        mask="999.999.999-99"
                        value={EmpresaStore.obs.empresa_edit.cpf_responsavel}
                        onChange={(e: any) =>
                          EmpresaStore.obs.empresa_edit.cpf_responsavel = e.target.value}
                      />
                    </FormGroup>

                    <FormGroup
                      label="Inscrição Estadual"
                      labelFor="inscricao-estadual"
                      style={{ width: "48%", float: "right" }}
                    >
                      {["RS", "SP", "MG", "PA"].includes(EmpresaStore.obs.empresa_edit.uf) ?
                        <InputMask
                          className="form-control"
                          mask={mascara_inscricao_estadual(EmpresaStore.obs.empresa_edit.uf)}
                          value={EmpresaStore.obs.empresa_edit.inscricao_estadual}
                          onChange={(e: any) => EmpresaStore.obs.empresa_edit.inscricao_estadual = e.target.value}
                        />
                        :
                        <InputGroup
                          id="inscricao-estadual"
                          value={EmpresaStore.obs.empresa_edit.inscricao_estadual}
                          onChange={(e: any) => EmpresaStore.obs.empresa_edit.inscricao_estadual = e.target.value}
                        />
                      }
                    </FormGroup>

                    <FormGroup
                      label="Tipo de Empresa"
                      labelFor="tipo"
                      style={{ width: "48%", float: "left" }}
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <HTMLSelect
                        onChange={(e) => this.handleCheckFilial(e.target.value)}
                        disabled
                      >
                        {EmpresaStore.obs.empresa_edit.filial
                          ? (
                            <>
                              <option value="">Selecione</option>
                              <option value="false">Matriz</option>
                              <option value="true" selected>Filial</option>
                            </>
                          )
                          : (
                            <>
                              <option value="">Selecione</option>
                              <option value="false" selected>Matriz</option>
                              <option value="true">Filial</option>
                            </>
                          )}
                      </HTMLSelect>
                    </FormGroup>

                    <FormGroup
                      label="Regime da Empresa"
                      labelFor="regime"
                      style={{ width: "48%", float: "left", marginLeft: "4%" }}
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <HTMLSelect
                        onChange={(e) => this.handleCheckRegime(e.target.value)}
                        id="regime"
                        disabled={EmpresaStore.obs.disableRegime ? true : false}
                      >
                        {EmpresaStore.obs.empresa_edit.regime_importacao == "COMPETÊNCIA"
                          ? (
                            <>
                              <option value="CAIXA">CAIXA</option>
                              <option value="COMPETÊNCIA" selected>
                                COMPETÊNCIA
                              </option>
                            </>
                          )
                          : (
                            <>
                              <option value="CAIXA" selected>CAIXA</option>
                              <option value="COMPETÊNCIA">COMPETÊNCIA</option>
                            </>
                          )}
                      </HTMLSelect>
                    </FormGroup>

                    <FormGroup label="Logradouro" style={{ width: "100%" }}>
                      <InputGroup
                        value={EmpresaStore.obs.empresa_edit.logradouro}
                        onChange={(e: any) => EmpresaStore.obs.empresa_edit.logradouro = e.target.value}
                      />
                    </FormGroup>

                    <FormGroup
                      label="Município"
                      labelFor="municipio"
                      style={{ width: "48%", float: "left" }}
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <HTMLSelect disabled id="municipio">
                        <option selected value={EmpresaStore.obs.empresa_edit.municipio}>{EmpresaStore.obs.empresa_edit.municipio}</option>
                      </HTMLSelect>
                    </FormGroup>

                    <FormGroup
                      label="Estado"
                      labelFor="estado"
                      style={{ width: "48%", float: "right" }}
                      labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                    >
                      <HTMLSelect disabled id="estado">
                        <option selected value={EmpresaStore.obs.empresa_edit.uf}>{EmpresaStore.obs.empresa_edit.uf}</option>
                      </HTMLSelect>
                    </FormGroup>

                  </div>

                </MDBCol>
              }
            />

            <Tab
              id="certificado"
              title="Certificado"
              panel={<EmpresaCertificado />}
            />

            <Tab
              id="tributacao"
              title="Tributações"
              panel={
                <EmpresaTributacao
                  handleSimplesNacionalExcesso={this.handleSimplesNacionalExcesso.bind(this)}
                  handleConvenioIcms10097Select={this.handleConvenioIcms10097Select.bind(this)}
                  haldleDisableValidSimples={this.haldleDisableValidSimples.bind(this)}
                  handleSimplesNacionalSelect={this.handleSimplesNacionalSelect.bind(this)}
                  handleMedicamentoUsoVeterinarioSelect={this.handleMedicamentoUsoVeterinarioSelect.bind(this)}
                  handleRegimeEspecialSelect={this.handleRegimeEspecialSelect.bind(this)}
                  handleAutoPecasSelect={this.handleAutoPecasSelect.bind(this)}
                  handlePortaaPortaSelect={this.handlePortaaPortaSelect.bind(this)}
                  handleIssTributadoFixoSelect={this.handleIssTributadoFixoSelect.bind(this)}
                />
              }
            />

            {EmpresaStore.obs.empresa_edit.simples_nacional &&
              <Tab
                id="pgdas"
                title="PGDAS"
                panel={
                  <EmpresaPgdas
                    handleCodAcesso={this.handleCodAcesso.bind(this)}
                    handleReceitaBrutaValid={this.handleReceitaBrutaValid.bind(this)}
                    haldleDisableValidSimples={this.haldleDisableValidSimples.bind(this)}
                    handlesDownloadpgdas={this.handlesDownloadpgdas.bind(this)}
                    receita_bruta={this.state.receita_bruta}
                    cod_acesso={this.state.cod_acesso}
                  />
                }
              />
            }

            {/* {EmpresaStore.obs.empresa_edit.uf == "PA" ? */}
              <Tab
                id="sefa"
                title="SEFA | e-CAC"
                panel={<EmpresaSefa />}
              />
              {/* : <></>} */}

            {municipios_liberados.includes(EmpresaStore.obs.empresa_edit.municipio) ?
              <Tab
                id="parauapebas"
                title="NFS-e Prefeitura"
                panel={<EmpresaParauapebas />}
              />
              : <></>}

            <Tab
              id="resultados"
              title="Cálculos"
              panel={<EmpresaCalculos />}
            />

            <Tab
              id="sped"
              title="SPED"
              panel={<EmpresaSped />}
            />

            <Tab
              id="caixapostal"
              title="Caixa Postal"
              panel={<EmpresaCaixaPostal />}
            />

            <Tab
              id="usuarios_cadastrados"
              title="Usuários Cadastrados"
              panel={
                <MDBCol md="12">
                  <HTMLTable className="table table-hover" style={{ width: "50%" }}>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Excluir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items}
                    </tbody>
                  </HTMLTable>
                </MDBCol>
              }
            />

          </Tabs>

        </MDBRow>

        <Button
          intent="primary"
          onClick={this.handleSave}
          loading={EmpresaStore.obs.working}
          style={{ marginRight: "10px", marginTop: 28 }}
        >
          Salvar Empresa
        </Button>
        <Button
          onClick={this.handleCancel}
          disabled={EmpresaStore.obs.working}
          style={{ marginTop: 28 }}
        >
          Cancelar
        </Button>

        <div style={{ marginBottom: 25 }} />

      </>

    );
  }
}
